import { ButtonSize } from "./ButtonIcon";

/**
 * Icon pixel sizes per button size. Kept on a parallel table to
 * `ButtonIcon` so a future "buttons get bigger" theme tweak can update
 * the icon sizing without touching every call site.
 */
export function getIconSize(size: ButtonSize): number {
  const sizes: Record<ButtonSize, number> = { large: 20, small: 12.8, normal: 16 };
  return sizes[size];
}
